import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    HopIcon} from 'lucide-react';

import LoadingButton from "../../Loading/LoadingButton";
  import anim_line from "../../img/winter.png"
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import WhatWillULearnProductAddMore from "./WhatWillULearnProductAddMore";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import Snackbar from "../../../Snackbar";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import FAQsProductAddMore from "./FAQsProductAddMore";
  
const FAQsProduct= ({sendBackData,setActiveCardOverview,baseUrl,})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
   const [goNextPopUp, setGoNextPopUp] =useState(false);
  
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
    let FAQs= courseData?.FAQs?JSON.parse(courseData?.FAQs):[]
 const [itemArr, setItemArr] = useState(FAQs);
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"FAQs":"");

     useEffect(() => {
        FAQs?.length !== 0?setItemArr(FAQs):
        setItemArr([{ no:1, id: generateTimestamp()
          ,paragraph:"" },]);
          
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
        setActiveCardOverview(true);
        
        // setCourseTitleData();
      },[])
   
 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
 courseData?.type=='batch'?"Batch":
 courseData?.type=="testSeries"?"Test Series":
 courseData?.type=="homeTutor"?"Home Tutor Offering":
 courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";


      const handleBack=(e)=>{
  
        setLoader({status:true});
        
        history.goBack();
        }
        
  const handleCreateProduct=()=>{
  
  
  
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2({FAQs:JSON.stringify(itemArr),type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setItemArr(JSON.parse(response?.course?.FAQs));
    setProductID(response?.course?.postId);
   setEditType("FAQs")
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemParagraph = (id, Paragraph) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, paragraph :Paragraph } : item
        
        ); 
        
        setItemArr(updatedItems);
      };
      const updateItemFAQ = (id, Paragraph) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, FAQ :Paragraph } : item
        
        ); 
        
        setItemArr(updatedItems);
      };
     
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    id: item.id,
  }));
  setItemArr(reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   
     return(<>
               {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}        
    <div >
    <div  className="ikcraft_login-signup-card-outerj "style={{marginBottom:"0px"}}><div  className="gridRightLittleSpaceFAQs contentPageScroller" style={{background:"#fff",borderRadius:"25px",}}>
  <div  className="CreateCourseStepsOuterRight " style={{background:"#f9f9f9",borderRadius:"25px",padding:"0px",margin:"2px"}}>
   
   <h1 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Add  What Will Students   <span className="coloredTextV1" >Learn </span>In Your {TypeTitle}? </h1>
   
<div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'150px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px"
           
          }}
        ></div>
            <div
             draggable 
                    
onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'move',
             
              
            }}  className={draggedIndex == item.id?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><FAQsProductAddMore index={index} key={item.id} 
        
            FAQs={item.FAQ}  id={item.id} 
              changeItemFAQ={updateItemFAQ } onRemove={removeItem}  />
          </div>
          
          </div>)):'' }
    
    <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New FAQ</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      ,  paragraph:"" }])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div>  </div>   <div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"2px",marginBottom:"80px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         
<div align="left" className="itemCourseOuter" style={{marginTop:"0px",margin:"2px",padding:"3px",marginBottom:"0px",background:"rgba(86, 82, 131,.8)"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"#fff",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><HopIcon size={32}  color="rgb(86, 82, 131)"/></div> 
              
                
                </div><div style={{display:"flex",justifyContent:"center"}}>
                <h2 style={{color:"#fff"}}>Next Step</h2> 
                  </div> 
                  <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={1} title ="What Will I Learn" onClickPopup={
          ()=>{  history.push(`${baseUrl}/what-will-i-learn`)
          }}  />
           </div> <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={2} title ="Target Audience" onClickPopup={
          ()=>{  history.push(`${baseUrl}/target-audience`)
          }}  />
           </div> <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={3} title ="Pre-requisite" onClickPopup={
          ()=>{  history.push(`${baseUrl}/prerequisite`)
          }}  />
           </div> <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={4} title ="Highlights" onClickPopup={
          ()=>{  history.push(`${baseUrl}/highlights`)
          }}  />
           </div> <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={5} title ="Skills" onClickPopup={
          ()=>{  history.push(`${baseUrl}/skills`)
          }}  />
           </div>    </div>
        </div>  </div>  </div>  </div> 
        {goNextPopUp?<NextStepCardPopUp loadingText="Going Next Phase..."  title="Next Phase> Enable Free Trial.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/trial`)
 },1000)
  }}/>:""}
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleBack()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div>
  
      
                                    
     </>)  
   }
   export default FAQsProduct;